export default __webpack_public_path__ + "static/pledge_water-fdd0d9d52b4b529f0f1c9ee8b6f7d618.webp";